/** ******** 客户管理 ********* */
// 获取业务员客户关系列表
export const getSalesmanCustomList = {
  url: '/admin/outUser/getOutUserList.json',
  method: 'get'
};

// 获取业务员类型
export const getSpecifiedSalesmanType = {
  url: '/admin/outUser/getSpecifiedSalesmanType.json',
  method: 'post'
};

// 清除客户关系
export const clearRelation = {
  url: '/admin/activityCustRelation/deleteCustomesBacth.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取绑定客户明细信息列表
export const getBindCusInfoList = {
  url: '/admin/outUser/getMaintainedCustomerList.json',
  method: 'get'
};

// 获取编辑详情客户类型列表
export const getCustomerType = {
  url: '/admin/activityCustRelation/getCustomerType.json',
  method: 'get'
};

// 保存后更新客户内容
export const backupDataByActivityId = {
  url: '/admin/outUser/backupDataByActivityId.json',
  method: 'get'
};

// 获取业务员团队列表
export const getSalesmanSupplierList = {
  url: '/admin/salesman/getSalesmanSupplierList',
  method: 'get'
};

// 获取编辑详情客户区域
export const getCustomerArea = {
  url: '/admin/activityCustRelation/getCustomerArea.json',
  method: 'get'
};

// 获取编辑详情补充客户单位
export const getAddedCustomers = {
  url: '/admin/activityCustRelation/getAddedCustomers.json',
  method: 'get'
};

// 获取编辑详情剔除客户单位
export const getRemovedCustomers = {
  url: '/admin/activityCustRelation/getRemovedCustomers.json',
  method: 'get'
};

// 获取地区树形数据
export const getAreaTree = {
  url: '/basic/area/tree_branch',
  method: 'get'
};

// 修改客户区域
export const addCustomerArea = {
  url: '/admin/activityCustRelation/addCustomerArea.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取客户类型列表
export const getCustomerTypeList = {
  url: '/admin/common/getCustomerType.json',
  method: 'get',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 添加客户类型
export const addCustomerTypes = {
  url: '/admin/activityCustRelation/addCustomerTypes.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const getCustomerList = {
  url: '/admin/common/addCustomer.json',
  method: 'get',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 添加客户
export const addCustomerIds = {
  url: '/admin/activityCustRelation/addCustomerIds.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除客户
export const delCustomer = {
  url: '/admin/activityCustRelation/deleteCustomers.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 批量导入客户
export const excelImportCutomer = {
  url: '/admin/outUser/excelImportCutomer'
};

// 存储编辑信息
export const saveCustomerAndValidateData = {
  url: '/admin/activityCustRelation/saveCustomerAndValidateData.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取发货方列表
export const getBranchCustInfoList = {
  url: '/admin/branch/getBranchCustInfoList',
  method: 'get'
};

// 获取发货方客户列表
export const getBranchBindingCustInfoList = {
  url: '/admin/branch/getBranchBindingCustInfoList',
  method: 'get'
};

// 解绑/绑定发货方客户关系
export const bindingBranchCustRelation = {
  url: '/admin/branch/bindingBranchCustRelation',
  method: 'post'
};

// 批量导入发货方客户关系列表
export const importBranchCustRelation = {
  url: '/admin/branch/importBranchCustRelation'
};
